import { useState, useEffect } from 'react'
import { Card, Drawer } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { BasePathProvider } from 'components/Providers'
import { useNavigate, useParams } from 'react-router-dom'
import SearchBar from './SearchBar'
import { get } from 'store/provider/academic-year'
import AcademicYearList from './List/List'
import AcademicYearSkeleton from './List/Skeleton'
import AcademicYearEditForm from './Form/Form'
import AcademicYear from './MarkingPeriodProvider/Page'
import Form from './Form/Form'

const baseUrl = '/settings/academic-year'

export default function AcademicYearsPage() {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [academicYear, setAcademicYear] = useState('')  
  const { academicYearId, edit } = useParams()
  const isEdit = edit === 'edit'

  const academicYearList = useSelector(state => state.provider.academicYear?.rows)

  useEffect(() => {
    if (academicYearId === 'new') {
      setAcademicYear({})
    } else if (+academicYearId) {
      academicYearId &&
        dispatch(get({ id: academicYearId })).then(res => {
          setAcademicYear(res.payload)
        })
      return
    } else {
      setAcademicYear(null)
    }
  }, [dispatch, academicYearId])

  return (
    <BasePathProvider value={`${baseUrl}`}>
      <Card sx={{ pt: 2 }} elevation={0}>
        <SearchBar />
        {academicYearList ? <AcademicYearList /> : <AcademicYearSkeleton />}
      </Card>
      <Drawer
        PaperProps={{
          sx: {
            width: isEdit || academicYearId === 'new' ? 600 : 1000,
          },
        }}
        open={Boolean(academicYearId)}
        anchor="right"
        onClose={() => navigate(baseUrl)}
      >
        {academicYearId === 'new' ? (
          <Form />
        ) : isEdit ? (
          academicYear && <AcademicYearEditForm academicYear={academicYear} />
        ) : (
          <AcademicYear academicYear={academicYear} />
        )}
      </Drawer>
    </BasePathProvider>
  )
}
